import { SVGProps } from 'react';

const ArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    className={props.className}
    onClick={props.onClick}
    fill={props.fill || 'currentColor'}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 20}
    height={props.height || 20}
    {...props}>
    <path d="M12 19c-.26 0-.52-.1-.71-.29l-6-6a1 1 0 1 1 1.42-1.42L12 16.59l5.29-5.3a1 1 0 0 1 1.42 1.42l-6 6c-.19.19-.45.29-.71.29z" />
  </svg>
);

export default ArrowDown;
